<template>
    <div id="companyMainPage">
        <div class="companyinfo-wraper" >
            <div class="companypic">
                <img :src="logoImage?logoImage:defaulheadimg" alt="">
                <div class="complete-ziliao" @click="gocoinfo">完善资料</div>
            </div>
            <div class="info-left">
                <div >
                    <span class="common-fz-co spanwidth">登录账号 :</span>
                    <span class="common-fz-co33">{{loginName}}</span>
                </div>
                <div class="left-div">
                    <span class="common-fz-co spanwidth">企业名称 :</span>
                    <el-tooltip class="item" effect="dark" :content="enterPriseName" placement="top">
                        <span class="common-fz-co33 work-elipse">{{enterPriseName}}</span>>
                    </el-tooltip>
                    
                </div>
                <div class="integrity left-div">
                    <span class="common-fz-co spanwidth">资料完整度 :</span>
                    <el-progress  :stroke-width="8" :percentage="completion" class="percent progress-wraper">
                    </el-progress>
                </div>
            </div>
            <div class="info-right">
                <div class="">
                    <span class="spanwidth2 common-fz-co">最近登录时间 :</span>
                    <span class="common-fz-co33">{{lastLoginTime}}</span>
                </div>
                <div class="right-div">
                    <span class="spanwidth2 common-fz-co">注册时间 :</span>
                    <span class="common-fz-co33">{{registTime}}</span>
                </div>
                <div class="right-div">
                    <span class="spanwidth2 common-fz-co">统一社会信用代码 :</span>
                    <span class="common-fz-co33">{{enterpriseCode}}</span>
                </div>
            </div>
        </div>
        <div class="mid-box">
            <div class="identify-box ">
                <div class="identify-left">
                    <div class="i-wraper">
                        <img :src="cetrify" alt="">
                    </div>
                    <div class="not-text">企业认证</div>
                    <span  v-if="certificatationStatus=='0'" class="not-certify common-certify">未认证</span>
                    <div v-else-if="certificatationStatus=='4'" class="certified common-certify">
                        已认证
                    </div>
                    <span v-else-if="certificatationStatus=='2'" class="failed-certify common-certify">未通过</span>
                    <span v-else-if="certificatationStatus=='1'" class="wait-certify common-certify">待审核</span>
                    
                </div>
                <div class="identify-right" v-show="certificatationStatus!='1'">
                    <div v-if="certificatationStatus=='0'" @click="gocoinfo">
                        <span >马上认证</span>
                        <span class="el-icon-arrow-right"></span>
                    </div>
                    <div v-else-if="certificatationStatus=='2'||certificatationStatus=='4'" @click="gocoinfo">
                        <span >重新认证</span>
                        <span class="el-icon-arrow-right"></span>
                    </div>
                </div>
            </div>
            <div class="width20"></div>
            <div class="addmember identify-box">
                <div class="addmember-left">
                    <div class="i-wraper">
                        <img :src="passwordset" alt="">
                    </div>
                    <span class="reset-pa">重置密码</span>
                </div>
                
                <div class="identify-right" @click="resetpass">
                    <span>重置密码</span>
                    <span class="el-icon-arrow-right"></span>
                </div>
            </div>
        </div>
        <div class="allproducts" v-if="enterprisePurchasedProducts.length">
            <div class="all-header common-fz-co33">
                <span style="border-left: 3px solid #0069e0;padding-left:8px">所有产品</span>
            </div>
            <div class="package-wraper">
                <div v-for="(item,index) in enterprisePurchasedProducts" 
                :key="index"
                class="item-style">
                    <el-tooltip v-if="item.packageName.length>25" class="item" effect="dark" :content="item.packageName" placement="top">
                        <p class="item-name" >{{item.packageName}}</p>
                    </el-tooltip>
                    <p class="item-name" v-else>{{item.packageName}}</p>
                    
                    <div class="detail-wraper">
                        <div>
                            <p class="fy-time">授权时间</p>
                            <el-progress type="circle" 
                            :percentage="item.restDay" 
                            :show-text="true" 
                            :format="format2" 
                            :width=progresswidth
                            :stroke-width=strokewidth 
                            color="#1DCB96"
                            class="restday"></el-progress>
                            <p class="common-matop12 common-fz12-co33">开始日期:{{item.startTime}}</p>
                            <p class="common-matop10 common-fz12-co33">结束日期:{{item.endTime}}</p>
                        </div>
                        <div>
                            <p class="fy-num">授权数量</p>
                            <el-progress 
                            type="circle" 
                            :percentage="item.restUse" 
                            :show-text="true" 
                            :format="format1" 
                            :width=progresswidth
                            :stroke-width=strokewidth
                            color='#FE833D'
                            class="restnummain"></el-progress>
                            <p class="common-matop12 common-fz12-co33">授权总数:{{item.TotalNum}}</p>
                            <p class="common-matop10 common-fz12-co33">已分配授权总数:{{item.hasFyTotalNum}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
import green from '@/assets/img/wxzfbpay/green.png'
import defaulheadimg from '@/assets/img/trialCenter/defaulheadimg.png'
import {EnterpriseUserIndex,enterPriseDetailInfo} from '@/js/enterPriseApi'
import Moment from 'moment'
import  {BASE_URL} from "../../../config/env"
import {GetUserHeadImageApi} from '@/js/api.js'
import passwordset from '@/assets/img/trialCenter/passwordset.png'
import cetrify from '@/assets/img/trialCenter/cetrify.png'
export default {
    name:"companyMainPage",
    data(){
        return {
            passwordset,
            cetrify,
            logoImage:null,
            defaulheadimg:defaulheadimg,
            greenpng:green,
            strokewidth:10,
            progresswidth:110,
            loginName:window.localStorage.getItem('userAccount')?
                    window.localStorage.getItem('userAccount'):'',//登录账号
            enterPriseName:'',//公司名
            registTime:'',//注册时间
            lastLoginTime:'',//登录时间
            enterpriseCode:'',//社会统一信用代码
            certificatationStatus:'',//认证状态
            completion:0,//资料完整度
            enterprisePurchasedProducts:[],//企业购买的产品
        }
    },
    created(){
        this.getCompanyInfo();
        this.getenterPriseLogo();
    },
    methods:{
        format1(val){
            if(val===0){
                return '0'
            }else{
                return val;
            }
        },
        format2(val){
            if(val===0){
                return '0'
            }else if(val==100){//避免控制台错误，当永久授权、默认给值100，格式化为无字符
                return '无'
            }
            else{
                return val;
            }
        },
        getenterPriseLogo(){//先获取企业详细信息
            let that=this;
            let params={
                enterPriseId:window.localStorage.getItem('enterPriseId')
            };
            enterPriseDetailInfo(params)
            .then(res=>{
                if(res.status===200 && res.data.error_code===0){
                    const {data}=res.data;
                    if(data===null){
                        console.log('1')
                    }else{
                        that.logoImage=data.logoImageInAliyunOSSViewPath       
                    }
                }else{
                    this.$message.error(res.data.error_msg)
                }
            })
            .catch(err=>{
                console.log(err)
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }
            })
        },
        gocoinfo(){//完善信息按钮点击
            this.$router.push('/companyInfo');
        },
        resetpass(){
            this.$router.push('/CompanySetPassword')
        },
        getCompanyInfo(){//获取企业主页信息
            let that=this;
            let params=window.localStorage.getItem('enterPriseId');
            EnterpriseUserIndex(params)
            .then(res=>{
                console.log(res)
                if(res.status===200 && res.data.error_code===0){
                    const {data}=res.data;
                    //that.loginName=data.loginName;
                    that.enterPriseName=data.enterpriseName;
                    that.enterpriseCode=data.enterpriseCode;
                    that.certificatationStatus=data.certificatationStatus;
                    that.completion=data.completion;
                    that.registTime=Moment(data.registTime).format('YYYY-MM-DD HH:mm:ss');
                    that.lastLoginTime=Moment(data.lastLoginTime).format('YYYY-MM-DD HH:mm:ss');

                    data.enterprisePurchasedProducts.forEach((item,index)=>{
                        let obj={
                            packageName:item.productName,
                            TotalNum:item.trialSnCount,//授权总数
                            hasFyTotalNum:item.hasUsedTrialSnCount,//已分配的授权总数
                            restUse:item.trialSnCount - item.hasUsedTrialSnCount,
                            productId:item.productId,
                            endTime:item.dueTime?Moment(item.dueTime).format('YYYY-MM-DD'):'',
                            startTime:item.startTime?Moment(item.startTime).format('YYYY-MM-DD'):'',
                            trialDays:item.trialDays,
                            restDay:item.remainingDays<0?0:item.remainingDays,
                            licensingType:item.licensingType,
                        };
                        if(obj.licensingType=='永久版'){
                            obj.restDay=100;//永久版本默认给100
                            obj.endTime='无';
                        }

                        that.enterprisePurchasedProducts.push(obj);
                    })

                    data.enterpriseSaasProducts.forEach((item,index)=>{
                        let obj2={
                            packageName:item.saasProductName,
                            TotalNum:item.trialSnCount,//授权总数
                            hasFyTotalNum:item.hasUsedTrialSnCount,//已分配的授权总数
                            restUse:item.trialSnCount - item.hasUsedTrialSnCount,
                            productId:item.mainId,
                            endTime:Moment(item.dueTime).format('YYYY-MM-DD HH:mm:ss'),
                            startTime:Moment(item.startTime).format('YYYY-MM-DD HH:mm:ss'),
                            trialDays:item.trialDays,
                            restDay:item.remainingDays<0?0:item.remainingDays,
                        };
                        that.enterprisePurchasedProducts.push(obj2);
                    })

                }else{
                    this.$message.error(res.data.error_msg)
                }
            })
            .catch(err=>{
                console.log(err)
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }
            })
        }
        
    }
}
</script>
<style lang="scss">
    #companyMainPage{
        .el-progress{
            .el-progress__text{
                top: 65px;
                font-family: FZLTZHK--GBK1-0;
                font-size: 18px !important;
                color: #333333;
                text-align: center;
                font-weight: 600;
            }
        }
        .percent{
            .el-progress__text{
                font-family: MicrosoftYaHei;
                font-size: 14px !important;
                color: #333333;
                font-weight: 400;
            }
        }
        .restday{
            .el-progress-circle::after{
                content:"剩余天数";
                position: absolute;
                top: 35px;
                width: 110px;
                left: 0;
                font-family: MicrosoftYaHei;
                font-size: 12px;
                color: #666666;
                text-align: center;
                font-weight: 400;
            }
        }
        .restnummain{
            .el-progress-circle::after{
                content:"剩余可用";
                position: absolute;
                top: 35px;
                width: 110px;
                left: 0;
                font-family: MicrosoftYaHei;
                font-size: 12px;
                color: #666666;
                text-align: center;
                font-weight: 400;
            }
        }
    }
</style>
<style lang="scss" scoped>
    #companyMainPage{
        background: #fafafa;
        .companyinfo-wraper{
            background: #fff;
            padding:30px 0 20px 40px;
            display: flex;
            .companypic{
                img{
                    width: 80px;
                    height: 80px;
                    border-radius: 50%;
                }
                .complete-ziliao{
                    cursor: pointer;
                    font-family: FZLTZHK--GBK1-0;
                    font-size: 12px;
                    color: #0069e0;
                    font-weight: 400;
                    margin-top: 8px;
                    text-align: center;
                }
            }
            .headpic{
                display: flex;
                align-items: center;
                justify-content: center;
                width: 80px;
                height: 80px;
            }
            .info-left{
                text-align: left;
                padding-left: 20px;
                padding-right: 30px;
                .left-div{
                    margin-top: 15px;
                }
                .integrity{
                    height: 28px;
                    line-height: 28px;
                    display: flex;
                    align-items: center;
                    /deep/ .el-progress{
                        width: 230px;
                    }
                    .progress-wraper{
                        /deep/ .el-progress-bar__inner{
                            background-image: linear-gradient(270deg, #FF7215 0%, #FFC611 100%);
                        }
                    }
                }
            }
            .info-right{
                padding-left: 30px;
                padding-bottom: 20px;
                text-align: left;
                border-left: 1px solid #DEE0E3;
                .right-div{
                    margin-top: 15px;
                }
            } 
        }
        .mid-box{
            margin-top: 12px;
            padding: 16px;
            height: 116px;
            display: flex;
            background: #fff;
            .width20{
                background: #fff;
                width: 16px;
            }
            .identify-box{
                flex: 1;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding-right: 40px;
                background: #F4F6F8;
                .identify-left{
                    display: flex;
                    padding-left: 40px;
                    align-items: center;
                    .not-text{
                        margin-left: 12px;
                        font-size: 16px;
                        color: #181818;
                    }
                    .certified{
                        background: #0069e0;
                    }
                    .not-certify{
                        background: #5D5D5D;
                    }
                    .wait-certify{
                        background: #ED8400;
                    }
                    .failed-certify{
                        background: #E4393C;
                    }
                    .common-certify{
                        padding: 2px 5px;
                        color: #fff;
                        font-size: 10px;
                        border-radius: 2px;
                        margin-left: 8px;
                    }

                }
                .identify-right{
                    cursor: pointer;
                    width: 100px;
                    height: 36px;
                    line-height: 36px;
                    font-size: 14px;
                    color: #0069e0;
                }
            }
            .addmember{
                flex: 1;
                .addmember-left{
                    display: flex;
                    align-items: center;
                    margin-left: 24px;
                    .reset-pa{
                        margin-left: 12px;
                        font-size: 16px;
                        color: #181818;
                    }
                }
            }
            .i-wraper{
                width: 54px;
                height: 54px;
                display:flex;
                justify-content: center;
                align-items: center;
                img{
                    width: 54px;
                    height: 54px;
                }
            }
        }
        .allproducts{
            margin-top: 12px;
            background: #fff;
            padding: 0 20px 20px 20px;
            .all-header{
                text-align: left;
                margin-left: 0px;
                line-height: 20px;
                border-bottom: 1px solid #EAEAEA;
                display: flex;
                align-items: center;
                height: 50px;
                color: #181818;
                font-weight: 700;
            }
            .package-wraper{
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                .item-style{
                    width: 49%;
                    margin-top: 16px;
                    border: 1px solid #EAEAEA;
                    .item-name{
                        height: 50px;
                        line-height: 50px;
                        background: #EBECEE;
                        font-family: FZLTZHK--GBK1-0;
                        font-size: 14px;
                        color: #333333;
                        text-align: center;
                        font-weight: 600;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow:ellipsis;
                        padding: 0 10px;
                    }
                }
                .detail-wraper{
                    display: flex;
                    justify-content: space-around;
                    padding-top: 20px;
                    padding-bottom: 30px;
                    .fy-time{
                        margin-bottom: 12px;
                        font-size: 12px;
                        color: #333;
                    }
                    .fy-num{
                        margin-bottom: 12px;
                        font-size: 12px;
                        color: #333;
                    }
                }
            }
        }
        //公共样式
        .common-fz-co{
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #999999;
            font-weight: 400;
        }
        .common-fz-co33{
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #333333;
            font-weight: 400;
        }
        .work-elipse{
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            max-width: 200px;
            word-break: break-all;
            display: inline-block;
        }
        .common-fz12-co33{
            font-family: MicrosoftYaHei;
            font-size: 12px;
            color: #333333;
        }
        .spanwidth{
            display: inline-block;
            width: 90px;
        }
        .spanwidth2{
            display: inline-block;
            width: 120px;
        }
        .common-matop12{
            margin-top: 10px;
        }
        .common-matop10{
            margin-top: 10px;
        }
        
    }
</style>


// WEBPACK FOOTER //
// src/view/CompanyUser/CompanyMainPage.vue